import 'whatwg-fetch';

class Api {

  static headers() {
    return {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'dataType': 'json',
      'Access-Control-Allow-Origin': '*',
    };
  }

  static get(route, token) {
    return this.xhr(route, null, 'GET', token);
  }

  static put(route, params, token) {
    return this.xhr(route, params, 'PUT', token);
  }

  static post(route, params, token) {
    return this.xhr(route, params, 'POST', token);
  }

  static delete(route, params, token) {
    return this.xhr(route, params, 'DELETE', token);
  }

  static patch(route, params, token) {
    return this.xhr(route, params, 'PATCH', token);
  }

  static xhr(route, params, verb, token = '') {
    const host = process.env.ROOT_URL;
    const url = `${host}${route}`;
    let options = Object.assign({ method: verb }, params ? { body: JSON.stringify(params) } : null );
    options.headers = Api.headers();
    if(token){
      options.headers["Authorization"] = "Bearer " + token;
    }
    if (verb == "POST" || verb == "PATCH") options.headers['Content-Type'] = 'application/json';
    
    //Thanks iOS 9 for freaking out if a header starts or ends with a space
    for (var key in options.headers) {
      if (options.headers.hasOwnProperty(key)) {
        options.headers[key] = options.headers[key].trim();
        if(key !== key.trim()){
          options.headers[key.trim()] = options.headers[key];
          delete options.headers[key];
        }
      }
    }
    return fetch(url, options).then(resp => {
      if (resp.ok && resp.statusText !== "No Content") {
        let json = resp.json().catch(err => ({success: 'true'}));
        return json;
      } else if (resp.status === 402) {
        let json = resp.json();
        return json;
      }
      return resp;
    }).then( json => {return json });
  }
}

export default Api;



// WEBPACK FOOTER //
// ./lib/api.js